import { formatAddressText, type AddressLike } from '~/utils/addressFormat';

export type LabelableLocation = {
  code: string;
  facility: { address: AddressLike };
};

export function locationPickerLabel(location: LabelableLocation): string {
  const address = formatAddressText(location.facility.address);
  return address ? `${location.code} — ${address}` : location.code;
}

export function locationCityLabel(location: LabelableLocation): string {
  const { city } = location.facility.address;
  return city ? `${location.code} · ${city}` : location.code;
}
